<template>
  <div class="p-steps">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'radioGroup',
  data: () => ({
    arr: null
  }),
  mounted () {
    this.arr = this.$slots.default.map(e => e.componentOptions)
    console.log(this.arr)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/radioGroup.vue